import { render, staticRenderFns } from "./MerchantDetails.vue?vue&type=template&id=9e169602&"
import script from "./MerchantDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports